<form class="signUp" [formGroup]="signUpForm" autocomplete="off">
  <div class="container-fluid signUpContainer mt-3">
    <div class="col-md-12">
      <div class="col-md-12 d-flex">
        <div class="card sgUpFrmCard">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="companyname" class="form-labe mandatoryLabel"
                  >Company Name
                  <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <div class="input-field">
                  <input
                    formControlName="companyname"
                    id="companyname"
                    TrimText
                    name="companyname"
                    class="form-control"
                    type="text"
                    placeholder="Enter company name"
                  />
                </div>
                @if (
                  f["companyname"].touched &&
                  f["companyname"].hasError("required")
                ) {
                  <span class="text-danger"> Company name is required. </span>
                }
                @if (
                  f["companyname"].touched &&
                  f["companyname"].hasError("pattern")
                ) {
                  <span class="text-danger"> Enter valid company name. </span>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="location" class="form-label mandatoryLabel"
                  >Company Location
                  <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <div class="input-field">
                  <input
                    formControlName="location"
                    id="location"
                    name="location"
                    TrimText
                    class="form-control"
                    type="text"
                    placeholder="Enter company location"
                  />
                </div>
                @if (
                  f["location"].touched && f["location"].hasError("required")
                ) {
                  <span class="text-danger">
                    Company location is required.
                  </span>
                }
                @if (
                  f["location"].touched && f["location"].hasError("pattern")
                ) {
                  <span class="text-danger"> Enter valid location. </span>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="username" class="form-label mandatoryLabel"
                  >User Name <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <div class="input-field">
                  <input
                    formControlName="username"
                    id="username"
                    TrimText
                    name="username"
                    class="form-control"
                    type="text"
                    placeholder="Enter user name"
                    autocomplete="off"
                  />
                </div>
                @if (
                  f["username"].touched && f["username"].hasError("required")
                ) {
                  <span class="text-danger"> User name is required. </span>
                }
                @if (
                  f["username"].touched && f["username"].hasError("pattern")
                ) {
                  <span class="text-danger"> Enter valid username. </span>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="transcribe" class="form-label mandatoryLabel"
                  >Transcribe <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <ng-select
                  placeholder="Choose/search"
                  formControlName="transcribe"
                  name="transcribe"
                  id="transcribe"
                  class="transcribeClass"
                >
                  @for (transcribe of transcribeList; track transcribe.id) {
                    <ng-option [value]="transcribe.id">{{
                      transcribe.name
                    }}</ng-option>
                  }
                </ng-select>
                @if (
                  f["transcribe"].touched &&
                  f["transcribe"].hasError("required")
                ) {
                  <span class="text-danger"> Transcribe is required. </span>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  for="email"
                  class="form-label mandatoryLabel"
                  [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                  >Email <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <div class="input-field">
                  <input
                    formControlName="email"
                    id="email"
                    TrimText
                    name="email"
                    class="form-control"
                    type="email"
                    placeholder="user@example.com"
                    autocomplete="off"
                  />
                </div>
                @if (f["email"].touched && f["email"].hasError("required")) {
                  <span class="text-danger"> Email is required. </span>
                }
                @if (f["email"].touched && f["email"].hasError("pattern")) {
                  <span class="text-danger"> Enter valid email. </span>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  for="password"
                  class="form-label mandatoryLabel"
                  [ngClass]="{
                    'is-invalid': submitted && f['password'].errors,
                  }"
                  >Password <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <div class="input-field">
                  <input
                    formControlName="password"
                    id="password"
                    TrimText
                    name="password"
                    class="form-control"
                    [type]="type"
                    placeholder="Enter password"
                    autocomplete="off"
                  />

                  <span style="position: relative">
                    <span
                      class="fa {{ eyeIcon }} passwordEye"
                      (click)="hideShowPassword()"
                      (keydown.enter)="hideShowPassword()"
                      (keydown.space)="hideShowPassword()"
                    ></span>
                  </span>
                </div>
                @if (
                  f["password"].touched && f["password"].hasError("required")
                ) {
                  <span class="text-danger"> Password is required. </span>
                }
                @if (
                  f["password"].touched && f["password"].hasError("minlength")
                ) {
                  <div class="text-danger">
                    Password must be at least 8 characters
                  </div>
                }
                @if (
                  f["password"].touched &&
                  f["password"].invalid &&
                  f["password"].hasError("pattern")
                ) {
                  <span class="text-danger">
                    Password must be at least 8 characters, and include at least
                    1 number and 1 special character( _, &#64;, or $).
                  </span>
                }
              </div>
            </div>
            <div class="col-md-6 lastTwoInput">
              <div class="form-group">
                <label
                  for="phonenumber"
                  class="form-label mandatoryLabel"
                  [ngClass]="{
                    'is-invalid': submitted && f['phonenumber'].errors,
                  }"
                  >Phone Number
                  <i class="fa-solid fa-asterisk mandatoryIcon"></i
                ></label>
                <div class="input-field">
                  <app-phone-number-input
                    #phoneComp
                    formControlName="phonenumber"
                    [isInvalid]="
                      (submitted || f['phonenumber'].touched) &&
                      !!f['phonenumber'].errors
                    "
                    [parentErrors]="f['phonenumber'].errors"
                    defaultCountry="US"
                  >
                  </app-phone-number-input>
                </div>

                @if (
                  f["phonenumber"].touched &&
                  f["phonenumber"].hasError("invalidNumber")
                ) {
                  <div class="text-danger">
                    Phone number is not Valid and must contain atleast 10
                    numbers
                  </div>
                }
              </div>
            </div>
            <div class="col-md-6 lastTwoInput">
              <div class="form-group">
                <label for="agent" class="form-label mandatoryLabel"
                  >File Upload Per Agent</label
                >
                <div class="input-field">
                  <input
                    formControlName="agent"
                    id="agent"
                    name="agent"
                    class="form-control"
                    type="number"
                    onkeydown="return event.keyCode !== 69;"
                    placeholder="Enter number"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-check">
                <input
                  class="form-check-input"
                  formControlName="terms"
                  [ngClass]="{ 'is-invalid': submitted && f['terms'].errors }"
                  type="checkbox"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  I"ve read and agree to the canstring ai
                  <a href="https://canstring.ai/terms-of-use" target="_blank"
                    >term of use</a
                  >
                  and
                  <a href="https://canstring.ai/privacy-policy" target="_blank"
                    >privacy policy</a
                  >
                </label>
                @if (submitted && f["terms"].errors) {
                  <div class="invalid-feedback">
                    @if (f["terms"].errors["terms"]) {
                      <div class="text-danger">Agree terms and policy</div>
                    }
                    @if (f["terms"].errors["requiredTrue"]) {
                      <div class="text-danger">
                        Phone number is not Valid and must contain atleast 10
                        numbers
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col-md-10 offset-md-1">
              <button
                class="btn btn-primary signInBtn"
                [disabled]="spinner"
                (click)="onSubmit()"
                (keydown.enter)="onSubmit()"
              >
                @if (spinner) {
                  <i
                    class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login"
                  >
                    <span class="sr-only">Loading...</span>
                  </i>
                }
                Sign Up
              </button>
              <p
                class="ReturnLoginTxt"
                (keydown.enter)="returnBack('login')"
                (keydown.space)="returnBack('login')"
                (click)="returnBack('login')"
                (keydown.enter)="returnBack('login')"
              >
                <a>Return to Log in</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
